module.exports = __webpack_public_path__ + "img/desabilitar.9eeadd12.svg";